import type {CanvasImage,ChatImageSlot} from './canvas-types';

type ChatQaBadge={passed:boolean;reason:string};
/** Inputs are already scoped by the active-project selectors. Live QA keeps its
 * precedence; cold reopened chats can use the same persisted verdict as Canvas.
 * Never infer quality from a filename, another workflow, or an ambiguous URL. */
export function chatImageQaBadge(slot:Pick<ChatImageSlot,'resolved'|'requestId'|'workflowRunId'>,images:readonly CanvasImage[],live:Readonly<Record<string,ChatQaBadge>>):ChatQaBadge|undefined {
 if(!slot.resolved)return undefined;
 const streamed=live[slot.resolved];
 if(streamed&&typeof streamed.passed==='boolean')return streamed;
 const sameRun=(image:CanvasImage)=>slot.workflowRunId==null||image.workflowRunId===slot.workflowRunId;
 const identified=slot.requestId?images.filter(image=>image.id===slot.requestId):[];
 const candidates=(identified.length?identified:images).filter(image=>image.src===slot.resolved&&sameRun(image));
 if(candidates.length!==1)return undefined;
 const image=candidates[0];
 if(typeof image.qaPassed!=='boolean')return undefined;
 return {passed:image.qaPassed,reason:image.qaReason||'This image needs quality review.'};
}
